module.exports = __webpack_public_path__ + "img/28-avatar male.bfd3cf01.png";